import {IS_BETA} from './localization';
import store from './store/index.js';

export default function registerBetaMiddleware(router) {
  router.beforeEach((to, from, next) => {
    const isBetaOnly = to.meta && to.meta.beta;

    const user = store.state.general.user
    // console.log("user", user)
    if (isBetaOnly && !IS_BETA) {
      return next('/');
    }
    if (to.meta && to.meta.permission) {
      // console.log("metaperm", to.meta.permission)
      if (user && "permissions" in user) {
        if (user.permissions.includes(to.meta.permission)) {
          return next();
        }
      }
    } else {
      return next();
    }


    return next('/glossary');
  });
}
